<template>
  <div class="support">
    <div class="support__text">
      {{ msg }}
    </div>
    <div class="support__control">
      <div class="support__email">
        <a href="mailto:info@uday.club">info@uday.club</a>
      </div>
      <a href="https://t.me/ivan_p_2" target="_blank" class="support__telegram-link">
        <div class="mr-1">Написать в Telegram</div>
        <img class="support__telegram" src="/images/icons/telegram-blue.svg">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {type: String, required: true}
  }
}
</script>

<style lang="scss">
.support {
  font-size: 12px;

  .support__text {
    text-align: center;
    color: #7a7a7a;
  }
  .support__email {
    a {
      color: #7a7a7a;
    }
  }
  .support__control {
    display: flex;
    justify-content: space-around;
    margin-top: 15px;
  }
  .support__telegram {
    width: 20px;
    height: 20px;
    opacity: 0.6;
  }
  .support__telegram-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #7a7a7a;
  }
}
</style>